import * as THREE from 'three';

export class loadHotspot{
    scene;
    scale = 2;
    material;
    hotspotList = [];
    constructor() {
        this.start();
    }

    start(){
        let textureLoader = new THREE.TextureLoader();
        textureLoader.load(`${process.env.BASE_URL}ui/发光点.png`,texture=>{
            this.material = new THREE.SpriteMaterial({
                color: 0xffffff,
                transaction: true,
                rotation: Math.PI/4,
                map: texture
            });
        });

        textureLoader = null;
    }

    createHotspot(oldModel,position,prop,action){
        let newprop;
        let userAgent = navigator.userAgent;
        var isture = userAgent.indexOf('Android')>-1||userAgent.indexOf('Adr')>-1
        if(isture){
            newprop = prop*0.85
        }else {
            newprop = prop
        }
        let appHotspot = new AppHotspot(oldModel,position,newprop,this.material,action);

        this.hotspotList.push({
            name: oldModel,
            appHotspot
        });

        appHotspot = null;
    }

    bind(scene){
        this.scene = scene;
    }

    add(name){
        this.hotspotList.forEach(child=>{
            if(child.name === name){
                this.scene.add(child.appHotspot.planmesh);
            }
        });
    }

    remove(name){
        this.hotspotList.forEach(child =>{
            if(child.name === name){
               this.scene.remove(child.appHotspot.planmesh);
            }
        });
    }
    clean(){
        this.hotspotList = [];
    }
    update(){
        this.scale += 0.01;
        this.hotspotList.forEach(child=>{
            child.appHotspot.update(this.scale*child.appHotspot.prop,this.scale*child.appHotspot.prop,this.scale*child.appHotspot.planmesh.scale.z)
        });
        if(this.scale >= 4){
            this.scale = 2;
        }
    }
}
export class AppHotspot{
    position;
    planmesh;
    action;
    prop;
    constructor(oldMadel,position,prop,material,action) {
        this.position = position;
        this.prop = prop;
        this.planmesh = new THREE.Sprite(material);
        this.planmesh.position.set(position.x,position.y,position.z);
        this.planmesh.action = action;
        this.planmesh.scale.set(1,1,1);
        this.planmesh.ishotspot = true;
        this.planmesh.name = oldMadel;
    }

    update(x,y,z){
        this.planmesh.scale.set(x,y,z);
    }
}
